import { render } from "./DashboardLeftFirstDoubleBanner.vue?vue&type=template&id=b417b0fa&scoped=true"
import script from "./DashboardLeftFirstDoubleBanner.vue?vue&type=script&lang=js"
export * from "./DashboardLeftFirstDoubleBanner.vue?vue&type=script&lang=js"

import "./DashboardLeftFirstDoubleBanner.vue?vue&type=style&index=0&id=b417b0fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b417b0fa"]])

export default __exports__